import * as _ from "lodash";

import { BarData } from "@ctra/api";

import { ChartContextType } from "../../../../providers";
import { SingleEntityBarChartProcessor } from "./Individual";
import { MultiEntityBarChartProcessor } from "./Combined";

export class Processor {
  static create(entities: ChartContextType<BarData>["values"]["entities"]) {
    if (_.size(entities) > 1) {
      return new MultiEntityBarChartProcessor();
    } else {
      return new SingleEntityBarChartProcessor();
    }
  }
}
